import { ShowRoomDto } from "api"
import { useIsDesktop } from "common/MediaQueries"
import { memo } from "react"
import styled from "styled-components"
import { useMapContext } from "../map/MapContext"
import ShowRoomItem from "./ShowRoomItem"

const StyledList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
`
const StyledListItem = styled.li``

const ShowRoomList = () => {
  const isDesktop = useIsDesktop()
  const { selectedStore, filterStores, onStoreClick } =
    useMapContext<ShowRoomDto>()

  return (
    <StyledList>
      {!!filterStores?.length && (
        <>
          {filterStores.map((item, i) =>
            isDesktop ? (
              <StyledListItem
                key={i}
                tabIndex={0}
                role="button"
                onClick={() => {
                  onStoreClick(item)
                }}
              >
                <ShowRoomItem
                  showRoom={item}
                  isShowRoomSelected={selectedStore?.id === item?.id}
                />
              </StyledListItem>
            ) : (
              <StyledListItem key={i}>
                <ShowRoomItem
                  showRoom={item}
                  isShowRoomSelected={selectedStore?.id === item?.id}
                />
              </StyledListItem>
            )
          )}
        </>
      )}
    </StyledList>
  )
}

export default memo(ShowRoomList)
